import imageCompression from 'browser-image-compression';

export const compressImageAndChangeToWebp = async (file: File) => {
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.1,
    useWebWorker: false,
    fileType: 'image/webp',
    maxWidthOrHeight: 2048,
  });
  // webp 파일로 변환
  const webpFile = new File(
    [compressed],
    file.name.replace(/\.\w+$/, '.webp'),
    {
      type: 'image/webp',
      lastModified: Date.now(),
    },
  );

  return webpFile;
};
